module.exports = __webpack_public_path__ + "img/tabler-icon-chart-arrows-vertical.f9a1cb57.svg";